<div class="fixed flex gap-3 z-[9999]" [ngClass]="toastPosition">
  @for (toast of toasts; track toast){
  <lib-toast
    class="block w-full"
    [message]="toast.message"
    [type]="toast.type"
    [position]="position"
  ></lib-toast>
  }
</div>
